__turbopack_context__.v({
  "handle": "Switch-module-scss-module__84wgeW__handle",
  "on": "Switch-module-scss-module__84wgeW__on",
  "switch": "Switch-module-scss-module__84wgeW__switch",
});
